import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './FeaturesLayout.css';
import { IFeatureSchema } from '../../../types';
import { BlockClip } from '../block_clip';
import { Card } from '../card';

const COUNT_FEATURES_ON_PREVIEW = 3;

export interface IFeaturesLayoutStateProps {
  featureList: IFeatureSchema[];
  isHidden?: boolean;
}

type TFeaturesLayoutProps = IFeaturesLayoutStateProps;

export class FeaturesLayout extends React.Component<TFeaturesLayoutProps> {
  public render() {
    const { featureList, isHidden } = this.props;

    if (isHidden || !featureList || !featureList.length) {
      return null;
    }

    return (
      <Card>
        <div className={styles['title']}>Особенности</div>
        <BlockClip size={COUNT_FEATURES_ON_PREVIEW} text="Все особенности">
          {featureList.map((feature, index) => (
            <div key={index} className={styles['feature']}>
              <div className={styles['description']}>{feature.description}</div>
              {feature.imageUrl ? (
                <img src={feature.imageUrl} alt={feature.description} className={styles['image']} />
              ) : (
                <img
                  src={feature.imageUrl}
                  alt={feature.description}
                  {...mergeStyles(styles['image'], styles['image--default'])}
                />
              )}
            </div>
          ))}
        </BlockClip>
      </Card>
    );
  }
}
